import {Component, ViewChild, ViewContainerRef} from '@angular/core';
import {NbIconLibraries, NbLayoutColumnComponent} from '@nebular/theme';
import {TranslateService} from '@ngx-translate/core';
import {Meta} from '@angular/platform-browser';
import {AboutUsService} from '@shared/services';
import {icon, Marker} from 'leaflet';
import {
  EXTRA_ICON_CONFIG,
} from '@shared/constants';
import {AllowedLanguagesEnum} from '@shared/enums';
import {RouterOutlet} from '@angular/router';

/**
 * App component
 * @selector mkad-app
 * @extends MkadBaseComponent
 * @standalone False
 */
@Component({
  selector: 'mkad-app',
  template: `
    <router-outlet/>
  `,
  standalone: true,
  imports: [RouterOutlet],
  providers: [AboutUsService],
})
export class AppComponent {
  @ViewChild(NbLayoutColumnComponent, {read: ViewContainerRef}) container!: ViewContainerRef;  //this is always undefined

  /**
   * @description
   * Constructor class
   * @param iconLibrary NbIconLibraries dependency injection
   * @param translate TranslateService dependency injection
   * @param meta Meta dependency injection
   */
  constructor(private readonly translate: TranslateService,
              private readonly iconLibrary: NbIconLibraries,
              private readonly meta: Meta) {
    this.setupIconConfig();
    this.initDefaultLang();
    this.loadMapSource();
    this.meta.updateTag({name: 'theme-color', content: 'rgba(60,132,243,0.75)'});
  }

  /**
   * @description
   * Method that init the library config
   * @private
   */
  private setupIconConfig(): void {
    this.iconLibrary.registerFontPack('fak', {packClass: 'fak', iconClassPrefix: 'fa'});
    this.iconLibrary.registerFontPack('far', {packClass: 'far', iconClassPrefix: 'fa'});
    this.iconLibrary.registerFontPack('fab', {packClass: 'fab', iconClassPrefix: 'fa'});
    this.iconLibrary.setDefaultPack('far');
  }

  /**
   * @description
   * Method that init the ngx-translate config
   * @private
   */
  private initDefaultLang(): void {
    const browserLangList: string[] = ['es', 'en'];
    this.translate.addLangs(browserLangList);
    this.translate.setDefaultLang(AllowedLanguagesEnum.en);
    this.translate.use(this.translate.getBrowserLang() ?? AllowedLanguagesEnum.es);
  }

  /**
   * @description
   * Method that load the local path of icons
   * @private
   */
  private loadMapSource(): void {
    Marker.prototype.options.icon = icon({...EXTRA_ICON_CONFIG});
  }

}
